import { create } from "zustand";
import { persist, devtools, createJSONStorage } from "zustand/middleware";

import {
  ICountryLangStore,
  IMasterCountry,
  IMasterMethod,
  IMasterOrigin,
  IMasterUser,
} from "./interface";

export const defaultCountry: IMasterCountry = {
  id: 0,
  country: "",
  country_code: 0,
  country_full_name: "",
  country_flag: "",
  latitude: null,
  longitude: null,
};
export const defaultUser = {
  isLogin: false,
  access_token: "",
  name: "",
  vendor_no: "",
  grade: "",
  trader_role_id: 0,
  country: "",
  sub: "",
  is_first_login: "false",
  id: 0,
  corporation_id: 0,
  corporation_code: "",
};

const countryLangStore = create<ICountryLangStore>()(
  devtools(
    persist(
      (set) => ({
        country: defaultCountry,
        langVersion: "0",
        lang: "en",
        user: defaultUser,
        productCode: [],
        masterMethod: [],
        masterOrigin: [],
        setCountry: (e: IMasterCountry) =>
          set((state: ICountryLangStore) => ({
            ...state,
            country: e,
          })),
        setLangVersion: (e: string | number) =>
          set((state: ICountryLangStore) => ({
            ...state,
            langVersion: e,
          })),
        setLang: (e: string) =>
          set((state: ICountryLangStore) => ({
            ...state,
            lang: e,
          })),
        setUser: (e: IMasterUser) =>
          set((state: ICountryLangStore) => ({
            ...state,
            user: e,
          })),
        setProductCode: (e: number[]) =>
          set((state: ICountryLangStore) => ({
            ...state,
            productCode: e,
          })),
        setMasterMethod: (e: IMasterMethod[]) =>
          set((state: ICountryLangStore) => ({
            ...state,
            masterMethod: e,
          })),
        setMasterOrigin: (e: IMasterOrigin[]) =>
          set((state: ICountryLangStore) => ({
            ...state,
            masterOrigin: e,
          })),
      }),
      {
        name: "qovis-oversea",
        storage: createJSONStorage(() => localStorage),
      }
    )
  )
);

export default countryLangStore;
